<template>
  <div
    class="card shadow-xl mb-3 hover:shadow-2xl transition-shadow cursor-pointer"
    @click="$emit('click')"
  >
    <div class="card-body p-4">
      <!-- 任务头部 -->
      <div class="flex items-start gap-3 mb-3">
        <div class="avatar placeholder">
          <div class="bg-neutral text-neutral-content rounded-full w-10 h-10">
            <img
              v-if="task.iconUrl?.startsWith('http')"
              :src="task.iconUrl"
              alt=""
              class="w-full h-full object-cover rounded-full"
            />
            <i
              v-else-if="task.iconUrl?.startsWith('iconify')"
              :class="task.iconUrl"
            />
            <i v-else class="iconify mingcute--to-do-line" />
          </div>
        </div>
        <div class="flex-1 min-w-0">
          <h3 class="font-semibold text-base-content mb-1">
            {{ task.title }}
          </h3>
          <p class="text-xs text-base-content/70 line-clamp-2">
            {{ task.description }}
          </p>
        </div>
        <div class="flex-shrink-0">
          <div
            :class="getStatusBadgeClass(task.userStatus)"
            class="badge badge-sm"
          >
            {{ $t(`userTask.status.${task.userStatus}`) }}
          </div>
        </div>
      </div>

      <!-- 任务进度 -->
      <!-- <div v-if="task.userStatus === UserTaskStatus.IN_PROGRESS">
        <div class="flex items-center mb-2 gap-4">
          <span class="text-xs text-base-content/70">进度：</span>
          <van-progress
            class="flex-1"
            :percentage="task.progress"
            stroke-width="4"
          />
        </div>
      </div> -->

      <!-- 任务奖励 -->
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-2">
          <div
            :class="getTypeTagClass(task.type)"
            class="badge badge-outline badge-sm"
          >
            {{ $t(`userTask.type.${task.type}`) }}
          </div>
          <div class="flex flex-wrap gap-1 items-center">
            <span class="text-xs text-base-content/70"> 完成可得 </span>
            <div
              v-for="reward in task.rewards"
              :key="reward.type"
              class="flex items-center gap-1 bg-accent/10 text-accent px-2 py-1 rounded-full text-xs"
            >
              <power-icon v-if="reward.type === 'powerCube'" />
              <crystal-icon v-if="reward.type === 'crystal'" />
              <!-- <equipment-icon
                v-if="reward.type === 'equipment'"
                :equipment="reward.equipment"
              /> -->

              <span>{{ reward.amount }}</span>
            </div>
          </div>
        </div>
        <div class="card-actions justify-end">
          <button
            v-if="task.userStatus === UserTaskStatus.COMPLETED"
            class="btn btn-primary btn-xs"
            @click.stop="$emit('claim')"
          >
            领取奖励
          </button>
          <button
            v-else-if="task.userStatus === UserTaskStatus.CLAIMED"
            class="btn btn-xs"
            disabled
          >
            已完成
          </button>
          <button
            v-else-if="task.userStatus === UserTaskStatus.IN_PROGRESS"
            class="btn btn-outline btn-xs"
            @click.stop="$emit('click')"
          >
            查看详情
          </button>
        </div>
      </div>
      <i v-if="false" class="iconify mdi--user-outline"></i>
      <i v-if="false" class="iconify mdi--home-outline"></i>
      <i v-if="false" class="iconify mdi--handshake-outline"></i>
      <i v-if="false" class="iconify mingcute--book-6-line"></i>
      <i v-if="false" class="iconify mdi--ear-hearing"></i>
      <i v-if="false" class="iconify mingcute--quill-pen-ai-line"></i>
      <i v-if="false" class="iconify mdi--palette-outline"></i>
      <i v-if="false" class="iconify mdi--planet-outline"></i>
      <i v-if="false" class="iconify mdi--partnership-outline"></i>

      <!-- 操作按钮 -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { UserTaskStatus } from "@/enums/mateEnums";
import { UserTask } from "@/types/entity";
import { getStatusBadgeClass, getTypeTagClass } from "./TaskStyle";

defineProps<{
  task: UserTask;
}>();

defineEmits<{
  click: [];
  claim: [];
}>();
</script>
